export default "__VITE_ASSET__CkPHFER4__"